import { Button, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import { useState } from 'react'
import { metodoPrograma } from '../../../components/api'

const ModalSelecionaAtendimento = ({ close }) => {
  const [atendimento, setAtendimento] = useState(null)

  const handleClose = async () => {
    const resp = await metodoPrograma('buscaCheckinPorAtendimento', {
      idAtendimento: atendimento?.[0]?.[0],
      idPaciente: atendimento?.[0]?.[1],
    })

    close(resp)
  }

  return (
    <Dialog maxWidth="lg" fullWidth open={true} onClose={close}>
      <DialogTitle>Selecione um Atendimento</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <AutoComplete
              InputLabelProps={{ shrink: true }}
              label="Atendimento"
              metodo="buscaAtendimento"
              value={atendimento}
              getOptionLabel={(item) =>
                Array.isArray(item) && item.length > 0
                  ? `Proposta ${item?.[0]?.[0] ?? '-'} - ${item?.[1] ?? ''}`
                  : ''
              }
              getOptionSelected={(option, value) =>
                option?.[0]?.[0] === value?.[0]?.[0]
              }
              onChange={(_, value) => setAtendimento(value)}
            />
          </Grid>
          <Grid item xs={6}>
            <Button fullWidth variant="contained" onClick={close}>
              fechar
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              color="primary"
              disabled={!atendimento}
              variant="contained"
              onClick={handleClose}
            >
              Criar Checkin
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalSelecionaAtendimento
